import { combineReducers } from 'redux';

import { tabelaAtividadeReducer } from './tabelaAtividadeReducer';
import { tabelaResponsaveisReducer } from './tabelaResponsaveisReducer';
import { documentacaoFileInfoReducer } from './documentacaoFileInfoReducer';
import { responseReducer } from './responseReducer';
import { stepperReducer } from './stepperReducer';
import { alertsReducer } from './alertsReducer';
import { pagamentoReducer } from './pagamentoReducer';
import { areaReducer } from './areaReducer';
import { loadingReducer } from './loadingReducer';
import { AutorizacaoState } from './autorizacaoReducer';
import { userReducer } from './userReducer';
import { dadoCadastralReducer } from './dadoCadastralReducer';
import { assinaturaReducer, assinaturaVigenteReducer } from './assinaturaReducer';

const appReducer = combineReducers({
  userState: userReducer,
  tabelaAtividadeState: tabelaAtividadeReducer,
  tabelaResponsaveisState: tabelaResponsaveisReducer,
  documentacaoFileInfoState: documentacaoFileInfoReducer,
  responseState: responseReducer,
  stepperState: stepperReducer,
  alertsState: alertsReducer,
  pagamentoState: pagamentoReducer,
  areaState: areaReducer,
  loadingReducer: loadingReducer,
  AutorizacaoState: AutorizacaoState,
  dadoCadastralState: dadoCadastralReducer,
  assinatura: assinaturaReducer,
  assinaturaVigente: assinaturaVigenteReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
